import * as Logger from "./logger.js";
import { HSComponent } from "./component.js";

export class HSButton extends HSComponent {
    constructor() {
        super();
    }

    async onLoad() {
        let container = this.shadowRoot.querySelector(".icon");
        if (container) {
            if (this.getAttribute("icon")) {
                const icon = document.createElement("img");
                icon.src = this.getAttribute("icon");
                icon.alt = this.title || "button icon";
                container.appendChild(icon);
            } else {
                container.remove();
            }
        }

        container = this.shadowRoot.querySelector(".title");
        if (container) {
            if (this.getAttribute("title")) {
                container.textContent = this.getAttribute("title");
            } else {
                container.remove();
            }
        }

        if (this.getAttribute("action")) {
            this.onEvent('click', () => {
                if (this.disabled) return;
                this.emit({ type: this.getAttribute("action"), button: this });
            });
        }

        this.setSelected(!!this.hasAttribute("selected"));
        this.setDisabled(this.hasAttribute('disabled'));
    }

    setSelected(selected) {
        const container = this.shadowRoot.querySelector(".container");
        if (container) {
            if (selected) {
                container.classList.add("selected");
            } else {
                container.classList.remove("selected");
            }
        }
    }

    setDisabled(disabled) {
        this.disabled = !!disabled;
        const container = this.shadowRoot.querySelector(".container");
        if (container) {
            container.classList.toggle('disabled', this.disabled);
            container.style.pointerEvents = this.disabled ? 'none' : '';
            container.style.opacity = this.disabled ? '0.5' : '';
        }
        this.setAttribute('aria-disabled', String(this.disabled));
    }

    // Updates the visible label after initial load (onLoad only reads the
    // "title" attribute once, and removes the .title element entirely when
    // it starts empty, so callers that need a changing label must start with
    // a non-empty title attribute).
    setTitle(text) {
        if (text) this.setAttribute('title', text); else this.removeAttribute('title');
        const container = this.shadowRoot.querySelector(".title");
        if (container) container.textContent = text || '';
    }
}
